import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {EventMessage, EventMessageType} from '../../../domain/event-message';
import {DateTimeUtilService} from '../../../services/date-time-util/date-time-util.service';
import {MessageStatus} from '../../../domain/message-status';
import {DecimalAmountPipe} from '../../../pipes/decimal-input/decimal-input.pipe';
import {flatMap, isDefined} from '../../utils';
import {TradePlanRateNotification} from 'src/app/domain/trade-plan-rate-notification';
import {LowerCasePipe} from '@angular/common';
import {DateFormatPipe} from '../../../pipes/date-format/date-format.pipe';
import {CompanyShortNamePipe} from '../../../pipes/company-short-name/company-short-name.pipe';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-notification-message',
  imports: [
    LowerCasePipe,
    DecimalAmountPipe,
    DateFormatPipe,
    CompanyShortNamePipe,
    TranslateModule
  ],
  templateUrl: './notification-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./notification-message.component.scss']
})
export class NotificationMessageComponent implements OnChanges {
  readonly MessageStatus = MessageStatus;
  readonly EventMessageType = EventMessageType;
  readonly DecimalAmountPipe = DecimalAmountPipe;
  readonly isDefined = isDefined;
  readonly TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX = 'notifications-page.notification.trade-plan-rate-notification.';

  @Input() event: EventMessage<object>;

  elapsedTimeLabel: string;
  projectEventsCount: number;
  tradePlanRateNotification: TradePlanRateNotification;

  constructor(private readonly dateTimeUtilService: DateTimeUtilService) {
  }

  ngOnChanges(): void {
    this.computeElapsedTimeLabel();
    if (isDefined(this.event) && this.event.eventMessageType === EventMessageType.TRADE_PLAN_RATE_NOTIFICATION) {
      this.tradePlanRateNotification = this.event.data as TradePlanRateNotification;
      this.projectEventsCount = Object.values(this.tradePlanRateNotification.projectToEventIds)
        .reduce(flatMap, [])
        .length;
    }
  }

  private computeElapsedTimeLabel(): void {
    this.elapsedTimeLabel = this.dateTimeUtilService.getTimeSinceLabel(this.event.createdDate);
  }
}
